module.exports = __webpack_public_path__ + "img/gywm_logo.31767db1.png";